export default __webpack_public_path__ + "static/tag-dont-2-light-d4024666e0d3b168b2033b263add07722c1e3955c2874358e33c72ab7cbb2e19.png";